import HolidayAdd from './newholidays';
import EditHoliday from './editholidays'
import { getEnvVariable } from '../../../modules/environmentalList';
const HolidaysGrid = {
    "title": "Holidays",
    "type": "grid",
    "key": "HolidaysGrid",
    "gridkey": 'HolidaysGrid',
    "name": "HolidaysGrid",
    "hasreport": true,
    "addRoute": true,
    "routeParams": { replace: 'holidays', param: 'Id', routeName: 'id' },
    values: {
        addOpen: false,
        editOpen: false,
        editInfo: null,
        load: false,
        allgriddata:null,
        navigateItem: null,
        navigation :null,
        reportOpen: false,
        loadreportfilter: null,
        ReportJsonQueryStr: null,
    },
    sharedValues: ['addOpen', 'editOpen', 'editInfo', 'allgriddata', 'navigateItem', 'navigation', 'loadreportfilter', 'ReportJsonQueryStr', 'reportOpen'],
    aliases: {
        addOpen: 'addOpen',
        editOpen: 'editOpen',
        editInfo: 'editInfo',
        allgriddata: 'allgriddata',
        navigateItem: 'navigateItem',
        navigation: 'navigation',
        reportOpen: 'reportOpen',
        loadreportfilter: 'loadreportfilter',
        ReportJsonQueryStr: 'ReportJsonQueryStr'
    },
    headerProps: {
        title: "Holidays",
        components: [
              {
                type: 'breadcrumbs',
                items: [
                    { "link": "Administration", "tab": 1, "materialicon": "spellcheck", href: getEnvVariable('InternalBasepath'), className: 'breadcrumb-item text-dark', class: 'text-dark' },
                    { "link": "Holidays", "materialicon": "celebration", className: 'breadcrumb-item ', class: '' }

                ],
            }
        ],
        actions: [
            {
                type: 'fab',
                icon: 'clear',
                name: 'clear',
                color: 'primary',
                title: 'Clear Filters',
                menucolor: '#22a9b3',
                hideon: 'clear',
                hidevalue: false
            },

            {
                type: 'menu',
                icon: 'excel',
                name: 'excel',
                color: 'primary',
                title: 'Export to Excel',
                menucolor: '#c90685',
                hideon: 'excel',
                hidevalue: false,
                items: [{
                    name: 'Export Current Page',
                    action: 'filtercurrent'
                },
                {
                    name: 'Export All Pages',
                    action: 'filterall'
                }
                ]
            },
            //   {
            //     type: 'fab',
            //     icon: 'reports',
            //     name: 'reports',
            //     color: 'primary',
            //     title: 'Save Report',
            //     menucolor: '#C85A54',
            //     hideon: 'reports',
            //     hidevalue: false
            // },
            {
                type: 'fab',
                icon: 'add',
                name: 'add',
                color: 'primary',
                hideon: 'addButton',
                hidevalue: true,
                title: 'Add Holidays',
                menucolor: '#36088a'
            },
        ]
    },
    "columns": [
        {
            "title": "Day",
            "field": "HolidayDay", 
            "show": true,
            "width": 120,
        },
        {
            "title": "Date",
            "field": "HolidayDate",
            "show": true,
            "width": 60,
            filter: "date",
            format: "{0:d}",
            convert: "MM/DD/YYYY"
        },
        {
            "title": "Status",
            "field": "StatusDesc",
            "show": true,
            "width": 60,
        },
        {
            "title": "Created By",
            "field": "CreatedByName",
            "show": true,
            "width": 100
        },
        {
            "title": "Created On",
            "field": "CreatedOn",
            "show": true,
            "width": 100,
            filter: "date",
            format: "{0:d}",
            convert: "MM/DD/YYYY hh:mm:ss A"
        },
        {
            "title": "Updated By",
            "field": "UpdatedByName",
            "show": true,
            "width": 100
        },
        {
            "title": "Updated On",
            "field": "UpdatedOn",
            "show": true,
            "width": 100,
            filter: "date",
            format: "{0:d}",
            convert: "MM/DD/YYYY hh:mm:ss A"
    },

    ],
    displayName:  'editInfo',
    allgriddata: 'allgriddata',
    navigateItem: 'navigateItem',
    navigation: 'navigation',
    loadreportfilter: 'loadreportfilter',
    ReportJsonQueryStr: 'ReportJsonQueryStr',
    mapActionsToEffects: {
        load: {
            rules: [{
                run: {
                    valid: [{
                        type: 'grid',
                        "read": [
                            {
                                 url: getEnvVariable('Admin')+`/api/Holidays/Grid?`,
                                //"url":"http://localhost:6004/api/Holidays/Grid?",
                                "matchProps": [{
                                    name: "routeid1",
                                    key: "routeid1",
                                }],
                                type: 'get',
                                saveAs: {
                                    key: 'data'
                                }
                            }
                        ]
                    },
                    ]
                }
            }]// 1 intital load
        },
        addOpen:{
            rules: [{
                check: [
                    {
                        condition: 'AND',
                        rules: [
                            {
                                "name": "addOpen",
                                "type": "!=",
                                "value": true,
                                "rules": []
                            }
                        ]
                    }
                ],
                run: {
                    valid: [{
                        type: 'grid',
                        "read": [
                            {
                                url: getEnvVariable('Admin')+`/api/Holidays/Grid?`,
                                //"url":"http://localhost:6004/api/Holidays/Grid?",
                                "matchProps": [{
                                    name: "routeid1",
                                    key: "routeid1",
                                }],
                                type: 'get',
                                saveAs: {
                                    key: 'data'
                                }
                            }
                        ]
                    },
                    ]
                }
            }]
        },
        editOpen:{
            rules: [{
                check: [
                    {
                        condition: 'AND',
                        rules: [
                            {
                                "name": "editOpen",
                                "type": "!=",
                                "value": true,
                                "rules": []
                            }
                        ]
                    }
                ],
                run: {
                    valid: [{
                        type: 'grid',
                        "read": [
                            {
                                 url: getEnvVariable('Admin')+`/api/Holidays/Grid?`,
                                 //"url":"http://localhost:6004/api/Holidays/Grid?",
                                 "matchProps": [{
                                    name: "routeid1",
                                    key: "routeid1",
                                }],
                                type: 'get',
                                saveAs: {
                                    key: 'data'
                                }
                            }
                        ]
                    },
                    ]
                }
            }]
        },
        'add': {
            rules: [
                {
                    run: {
                        valid: [
                            {
                                type: 'value',
                                key: 'addOpen',
                                result: true
                            },

                        ]
                    }
                }
            ]
        },
        'display': {
            rules: [
                {
                    run: {
                        valid: [
                            {
                                type: 'value',
                                key: 'editOpen',
                                result: true
                            },
                            {
                                type: 'resultvalue',
                                name: 'editInfo',
                            },
                            {
                                type: 'resultvalue',
                                name: 'allgriddata',
                            },
                            {
                                type: 'resultvalue',
                                name: 'navigateItem',
                            },
                            {
                                type: 'resultvalue',
                                name: 'navigation',
                            },

                        ]
                    }
                }
            ]
        },
        'report': {
            rules: [
                {
                    run: {
                        valid: [
                            {
                                type: 'value',
                                key: 'reportOpen',
                                result: true
                            },
                            {
                                type: 'resultvalue',
                                name: 'loadreportfilter',
                            },
                            {
                                type: 'resultvalue',
                                name: 'ReportJsonQueryStr',
                            },

                        ]
                    }
                }
            ]
        },
    }



}

const HolidaysReport = {
    type: 'popup',
    key: 'HolidaysReport',
    name: 'HolidaysReport',

    anchor: 'right',
    open: false,
    aliases: {
        open: 'reportOpen'
    },
    sharedValues: ['open', 'loadreportfilter', 'ReportJsonQueryStr'],
    container: {
        values: {
            loadreportfilter: null,
            ReportJsonQueryStr: null
        },
        mapValues: {
            Report: [
                {
                    key: 'ReportJsonQueryStr',
                    name: 'ReportJsonQueryStr'
                },
                {
                    key: 'loadreportfilter',
                    name: 'loadreportfilter'
                },
            ],
        },
        mapActionsToEffects: {},
        layout: {
            group: [
                {
                    order: 0,
                    type: 'div',
                    className: '',
                    components: [
                        {
                            name: 'Report'
                        },
                    ]
                }
            ]

        },
        components: {
            Report: {
                "type": "form",
                "key": "Report",
                "name": "Report",
                aliases: {

                },
                sharedValues: ['ReportJsonQueryStr', 'loadreportfilter'],
                values: {
                    loadreportfilter: null,
                    ReportJsonQueryStr: null
                },
                mapActionsToEffects: {},
                layout: {
                    group: [
                        {
                            order: 0,
                            type: 'div',
                            className: '',
                            components: [{
                                name: 'ReportJsonQueryStr',
                                type: 'div',

                            },
                            {
                                name: 'loadreportfilter',
                                type: 'div',

                            }],

                        },
                    ],
                },
                "components": {
                    "ReportJsonQueryStr": {
                        "type": "gridreport",
                        "gridkey": 'HolidaysGrid',
                    },
                },
            }
        }
    }
}

const HolidaysContainer = {
    type: 'container',
    key: 'HolidaysContainer',
    values: {
        addOpen: false,
        editOpen: false,
        editInfo: null,
        allgriddata: null,
        navigateItem: null,
        navigation :null,
        loadreportfilter: null,
        ReportJsonQueryStr: null,
        reportOpen : false,
    },
    mapValues: {
        HolidayAdd: [
            {
                key: 'addOpen',
                name: 'open'
            }
        ],
        EditHoliday: [
            {
                key: 'editOpen',
                name: 'open'
            },
            {
                key: 'editInfo',
                name: 'editInfo'
            },
            {
                key: 'allgriddata',
                name: 'allgriddata'
            },
            {
                key: 'navigateItem',
                name: 'navigateItem'
            },
            {
                key: 'navigation',
                name: 'navigation'
            },
        ],
        HolidaysGrid: [
            {
                key: 'editOpen',
                name: 'editOpen'
            },
            {
                key: 'addOpen',
                name: 'addOpen'
            },
            {
                key: 'reportOpen',
                name: 'reportOpen'
            },
            {
                key: 'ReportJsonQueryStr',
                name: 'ReportJsonQueryStr'
            },
            {
                key: 'loadreportfilter',
                name: 'loadreportfilter'
            },
        ],
        HolidaysReport: [
            {
                key: 'reportOpen',
                name: 'open'
            },
            {
                key: 'loadreportfilter',
                name: 'loadreportfilter'
            },
            {
                key: 'ReportJsonQueryStr',
                name: 'ReportJsonQueryStr'
            },

        ]

    },
    mapActionsToEffects: {
        'addOpen': {
            rules: [
                {
                    check: [
                        {
                            condition: 'AND',
                            rules: [
                                {
                                    "name": "addOpen",
                                    "type": "!=",
                                    "value": true,
                                    "rules": []
                                }
                            ]
                        }
                    ],
                    uncheck:true,
                    run: {
                        valid: [
                            {
                                type: 'removelayout',
                                name: 'HolidayAdd',
                            }

                        ],
                        inValid:[
                            {
                                type: 'addlayout',
                                name: 'HolidayAdd',
                            }
                        ]
                    }
                }
            ]
        },
        'editOpen': {
            rules: [
                {
                    check: [
                        {
                            condition: 'AND',
                            rules: [
                                {
                                    "name": "editOpen",
                                    "type": "!=",
                                    "value": true,
                                    "rules": []
                                }
                            ]
                        }
                    ],
                    uncheck:true,
                    run: {
                        valid: [
                            {
                                type: 'removelayout',
                                name: 'EditHoliday',
                            }

                        ],
                        inValid:[
                            {
                                type: 'addlayout',
                                name: 'EditHoliday',
                            }
                        ]
                    }
                }
            ]
        },
        'reportOpen': {
            rules: [
                {
                    check: [
                        {
                            condition: 'AND',
                            rules: [
                                {
                                    "name": "reportOpen",
                                    "type": "!=",
                                    "value": true,
                                    "rules": []
                                }
                            ]
                        }
                    ],
                    uncheck: true,
                    run: {
                        valid: [
                            {
                                type: 'removelayout',
                                name: 'HolidaysReport',
                            }

                        ],
                        inValid: [
                            {
                                type: 'addlayout',
                                name: 'HolidaysReport',
                            }
                        ]
                    }
                }
            ]
        },
    },
    layout: {
        group: [
            {
                order: 0,
                type: 'div',
                className: 'row',
                components: [
                    {
                        name: 'HolidaysGrid'
                    },
                    // {
                    //     name: 'NoteAdd'
                    // },
                    // {
                    //     name: 'NoteEdit'
                    // },
                ]
            }
        ]

    },
    components: {
        HolidaysGrid: HolidaysGrid,
        HolidayAdd: HolidayAdd,
        EditHoliday: EditHoliday,
        HolidaysReport:HolidaysReport
    }
}


export default HolidaysContainer

